import { GET_SPOT_TRADE_PAIR, GET_SPOT_TRADE_PAIR_ERROR, GET_SPOT_TRADE_PAIR_REQUEST, UPDATE_SPOT_TRADE_PAIR_DATA, REMOVE_SPOT_TRADE_PAIR } from "../../ActionTypes/ActionTypes.js";

const initialState = {
    spotTradePairLoading: false,
    spotTradePairData: null,
    spotTradePairError: null,
    spotTradePairStatus: null,
    isModified: false,
    isFirstLoad: true,


};

const SpotTradePairReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_SPOT_TRADE_PAIR_REQUEST:
            return { ...state, spotTradePairLoading: true, spotTradePairStatus: null, spotTradePairData: null };
        case GET_SPOT_TRADE_PAIR:
            return {
                spotTradePairLoading: false, spotTradePairData: action.payload, spotTradePairError: null, spotTradePairStatus: action?.payload?.success,

                isFirstLoad: false,
            };

        case GET_SPOT_TRADE_PAIR_ERROR:
            return { spotTradePairLoading: false, spotTradePairData: null, spotTradePairError: action?.payload, spotTradePairStatus: action?.payload?.success, isFirstLoad: false, };
        case UPDATE_SPOT_TRADE_PAIR_DATA:
            return {
                ...state,
                spotTradePairData: {
                    ...state.spotTradePairData,
                    result: {
                        ...state.spotTradePairData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_SPOT_TRADE_PAIR:
            return { ...state, spotTradePairData: null, spotTradePairError: null, isModified: false, spotTradePairStatus: null, isFirstLoad: true, spotTradePairLoading: false }
        default:
            return state;
    }
};

export default SpotTradePairReducer;